import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import "./scripts/firebase";
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonContent,
  IonBadge,
  IonChip,
  IonAvatar,
  IonLabel,
  IonFooter,
  IonMenu,
  IonMenuToggle,
  IonButton,
  IonIcon,
} from "@ionic/vue";
import { IonApp, IonRouterOutlet, toastController } from "@ionic/vue";
import { useAuthStore } from "./store";
import { menu, cartOutline } from "ionicons/icons";
import { onMounted } from "vue";
import LoginModal from "./views/LoginModal.vue";
import { getMessaging, onMessage } from "firebase/messaging";
import router from "./router";
import { RouterView } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authStore = useAuthStore();

authStore.loadFromLocalStorage();

const messaging = getMessaging();
onMessage(messaging, async (payload) => {
  if (payload.notification) {
    console.log("Message received. ", payload);
    const toast = await toastController.create({
      message: `${payload.notification.title}\n${payload.notification.body}`,
      duration: 5000,
      position: "top",
      cssClass: "toast",
    });
    toast.onclick = (ev) => {
      if (["story", "section"].includes(payload.data?.type)) {
        router.push("/story/" + payload.data.storyId + "/read");
      }
      if (["proposal"].includes(payload.data?.type)) {
        router.push("/story/" + payload.data.storyId + "/proposals");
      }
    };
    await toast.present();
  }
});

onMounted(() => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("firebase-messaging-sw.js", {
      scope: "./",
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { id: "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRouterOutlet), { style: {"max-width":"1024px","margin-left":"auto","margin-right":"auto"} })
        ]),
        _: 1
      }),
      _createVNode(LoginModal)
    ]),
    _: 1
  }))
}
}

})